import { ReactNode } from 'react';

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from '@components/MDBox';

// Material Dashboard 2 PRO React TS contexts
import { useMaterialUIController } from '@context/MDContext';
import MDTypography from '@components/MDTypography';

// Declaring props types for DataTableHeadCell
interface Props {
  width?: string | number;
  children: ReactNode;
  align?: 'left' | 'right' | 'center';
  border?: string;
}

function DataTableHeadCell({
  width,
  children,
  align,
  border,
  ...rest
}: Props): JSX.Element {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox component='th' width={width} py={1.5} px={3} borderRight={border}>
      <MDBox
        {...rest}
        position='relative'
        textAlign={align}
        color={darkMode ? 'white' : 'secondary'}
        opacity={0.7}
      >
        <MDTypography
          variant='h6'
          color='info'
          sx={() => ({
            textTransform: 'uppercase'
          })}
        >
          {children}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// Declaring default props for DataTableHeadCell
DataTableHeadCell.defaultProps = {
  width: 'auto',
  sorted: 'none',
  align: 'left'
};

export default DataTableHeadCell;
